<div class="card">
  <div class="card-content imt-page">
    <section class="filter-bar filter-bar-collapsible mb-4" [class.filter-bar-visible]="pageHeaderService.currentFiltersVisible">
      <div class="filter-bar-filters">
        <div class="filter-field">
          <label class="filter-label" for="imt-account-manager">Account manager</label>
          <p-select
            id="imt-account-manager"
            [(ngModel)]="selectedAccountManager"
            (ngModelChange)="onFilterChange()"
            [options]="accountManagerOptions"
            optionLabel="label"
            optionValue="value"
            placeholder="All"
            [showClear]="true"
            [filter]="true"
            filterPlaceholder="Search..."
            panelStyleClass="filter-dropdown-panel"
            appendTo="body" />
        </div>
        <div class="filter-field">
          <label class="filter-label" for="imt-manager">Manager</label>
          <p-select
            id="imt-manager"
            [(ngModel)]="selectedManager"
            (ngModelChange)="onFilterChange()"
            [options]="managerOptions"
            optionLabel="label"
            optionValue="value"
            placeholder="All"
            [showClear]="true"
            [filter]="true"
            filterPlaceholder="Search..."
            panelStyleClass="filter-dropdown-panel"
            appendTo="body" />
        </div>
        <div class="filter-field">
          <label class="filter-label" for="imt-year">Year</label>
          <p-select
            id="imt-year"
            [(ngModel)]="selectedYear"
            (ngModelChange)="onFilterChange()"
            [options]="yearOptions"
            optionLabel="label"
            optionValue="value"
            placeholder="All"
            [showClear]="true"
            [filter]="true"
            filterPlaceholder="Search..."
            panelStyleClass="filter-dropdown-panel"
            appendTo="body" />
        </div>
        <div class="filter-field">
          <label class="filter-label" for="imt-month">Month</label>
          <p-select
            id="imt-month"
            [(ngModel)]="selectedMonth"
            (ngModelChange)="onFilterChange()"
            [options]="monthOptions"
            optionLabel="label"
            optionValue="value"
            placeholder="All"
            [showClear]="true"
            [filter]="true"
            filterPlaceholder="Search..."
            panelStyleClass="filter-dropdown-panel"
            appendTo="body" />
        </div>
      </div>

      <div class="filter-bar-actions" *ngIf="hasActiveFilters()">
        <button
          type="button"
          class="btn-clear-filters"
          (click)="clearFilters()"
          title="Clear all filters">
          <i class="pi pi-filter-slash"></i>
        </button>
      </div>
    </section>

    <section class="stats-cards-row imt-kpi-row">
      <article class="stats-card">
        <div class="stats-card-main">
          <span class="stats-card-label">Milestones due this month</span>
          <span class="stats-card-value imt-kpi">{{ milestonesDueThisMonth }}</span>
          <span class="stats-card-sublabel">This week: 2 due</span>
        </div>
      </article>
      <article class="stats-card">
        <div class="stats-card-main">
          <span class="stats-card-label">Invoices raised</span>
          <span class="stats-card-value imt-kpi imt-kpi--success">{{ invoicesRaised }}</span>
          <span class="stats-card-sublabel">1 issue today</span>
        </div>
      </article>
      <article class="stats-card">
        <div class="stats-card-main">
          <span class="stats-card-label">Awaiting invoice</span>
          <span class="stats-card-value imt-kpi imt-kpi--warning">{{ awaitingInvoice }}</span>
          <span class="stats-card-sublabel">Milestone completed</span>
        </div>
      </article>
      <article class="stats-card">
        <div class="stats-card-main">
          <span class="stats-card-label">Overdue invoices</span>
          <span class="stats-card-value imt-kpi imt-kpi--danger">{{ overdueInvoices }}</span>
          <span class="stats-card-sublabel">Escalation needed</span>
        </div>
      </article>
    </section>

    <section class="imt-grid">
      <article class="imt-panel">
        <header class="imt-panel-header">
          <h3>Invoice milestone status — all projects</h3>
        </header>
        <p-table
          [value]="milestoneRows"
          [tableStyle]="{ 'min-width': '100%' }"
          [scrollable]="true"
          scrollHeight="360px"
          styleClass="p-datatable no-column-lines compact-striped-table imt-table table-no-xscroll">
          <ng-template pTemplate="header">
            <tr>
              <th>Project</th>
              <th>Milestone</th>
              <th>Due date</th>
              <th>Status</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr>
              <td class="imt-project">{{ row.project }}</td>
              <td>{{ row.milestone }}</td>
              <td>{{ row.dueDate }}</td>
              <td><span [class]="statusClass(row.status)">{{ row.status }}</span></td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr class="table-empty-row table-empty-row--compact">
              <td colspan="4" class="table-empty-cell">
                <div class="empty-state empty-state--compact">
                  <div class="empty-icon"><i class="pi pi-inbox"></i></div>
                  <p class="empty-message">No milestones in view</p>
                  <p class="empty-description">Adjust the year/month or clear the filters</p>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </article>

      <div class="imt-side">
        <article class="imt-panel">
          <header class="imt-panel-header">
            <h3>Invoice status breakdown</h3>
          </header>
          <p-table
            [value]="invoiceStatusRows"
            [tableStyle]="{ 'min-width': '100%' }"
            [scrollable]="true"
            scrollHeight="360px"
            styleClass="p-datatable no-column-lines compact-striped-table imt-table table-no-xscroll">
            <ng-template pTemplate="header">
              <tr>
                <th>Status</th>
                <th class="imt-th-right">Count</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
              <tr>
                <td>{{ row.status }}</td>
                <td class="imt-th-right">{{ row.count }}</td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr class="table-empty-row table-empty-row--compact">
                <td colspan="2" class="table-empty-cell">
                  <div class="empty-state empty-state--compact">
                    <div class="empty-icon"><i class="pi pi-inbox"></i></div>
                    <p class="empty-message">No invoice data</p>
                    <p class="empty-description">Adjust the year/month or clear the filters</p>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </article>

        <article class="imt-panel">
          <header class="imt-panel-header">
            <h3>Payment alerts</h3>
          </header>
          <div class="alerts-list">
            @for (alert of paymentAlertRows; track alert.project + alert.note) {
              <div class="alert-row">
                <div>
                  <div class="alert-project">{{ alert.project }}</div>
                  <div class="alert-note">{{ alert.note }}</div>
                </div>
                <span [class]="alertClass(alert.severity)">{{ alert.severity === 'high' ? 'Overdue' : 'Due soon' }}</span>
              </div>
            }
          </div>
        </article>
      </div>
    </section>
  </div>
</div>
